"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var Input_1 = __importDefault(require("../Input"));
var wallets_1 = require("../../../wallets");
var core_1 = __importDefault(require("@aws-amplify/core"));
var auth_1 = __importDefault(require("@aws-amplify/auth"));
var aws_exports_1 = __importDefault(require("../../../actions/aws-exports"));
var CountriesList_1 = require("./CountriesList");
var react_autosuggest_1 = __importDefault(require("react-autosuggest"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var wallet_1 = require("../../../actions/wallet");
var react_device_detect_1 = require("react-device-detect");
core_1.default.configure(aws_exports_1.default);
var getSuggestions = function (value) {
    var inputValue = value ? value.trim().startsWith("+") ? value.trim() : "+" + value.trim() : "";
    var inputLength = inputValue.length;
    return inputLength === 0 ? CountriesList_1.countries : CountriesList_1.countries.filter(function (country) {
        return country.dial_code.slice(0, inputLength) === inputValue;
    });
};
var renderSuggestion = function (suggestion) { return (React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
    React.createElement("div", { style: { width: '80%' } }, suggestion.name),
    React.createElement("div", { style: { width: '20%', textAlign: 'right' } }, suggestion.dial_code))); };
var mapStateToProps = function (state) {
    var walletState = state.WalletReducer;
    return {
        walletTranslations: walletState.get("walletTranslations"),
        LocalWallet: walletState.get("LocalWallet") || wallets_1.HydroWallet
    };
};
exports.verifyAuth = function () { return __awaiter(_this, void 0, void 0, function () {
    var user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, auth_1.default.currentAuthenticatedUser()];
            case 1:
                user = _a.sent();
                return [2, user.signInUserSession.idToken.jwtToken];
        }
    });
}); };
exports.getUserName = function () { return __awaiter(_this, void 0, void 0, function () {
    var user;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, auth_1.default.currentAuthenticatedUser()];
            case 1:
                user = _a.sent();
                return [2, user.username];
        }
    });
}); };
exports.signOut = function () {
    auth_1.default.signOut();
    localStorage.removeItem("CENTRALIZED_WALLET_UserPublicAddress");
};
exports.signIn = function (userName) { return __awaiter(_this, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, auth_1.default.signIn(userName)];
            case 1:
                res = _a.sent();
                return [2, res];
        }
    });
}); };
exports.verifyOTP = function (session, otp) { return __awaiter(_this, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, auth_1.default.sendCustomChallengeAnswer(session, otp)];
            case 1:
                res = _a.sent();
                return [2, res];
        }
    });
}); };
var myInterval;
var Login = (function (_super) {
    __extends(Login, _super);
    function Login(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (event, _a) {
            var newValue = _a.newValue, method = _a.method;
            if (method === 'type') {
                _this.setState({
                    phone: "",
                    otp: "",
                    processing: false,
                    requireOTP: false,
                    loginSuccessful: false,
                    resendOTP: false,
                    errorMsg: null,
                    session: null,
                    minutes: 0,
                    seconds: 0
                });
            }
            if (newValue === "") {
                return;
            }
            _this.setState({
                countryCode: newValue
            });
        };
        _this.onSuggestionsFetchRequested = function (_a) {
            var value = _a.value;
            _this.setState({
                suggestions: getSuggestions(value)
            });
        };
        _this.onSuggestionsClearRequested = function () {
            _this.setState({
                suggestions: []
            });
        };
        _this.getSuggestionValue = function (suggestion) {
            return suggestion.dial_code;
        };
        _this.state = {
            phone: "",
            otp: "",
            processing: false,
            requireOTP: false,
            loginSuccessful: false,
            resendOTP: false,
            errorMsg: null,
            session: null,
            minutes: 0,
            seconds: 0,
            countryCode: "+82",
            suggestions: []
        };
        return _this;
    }
    Login.prototype.componentDidUpdate = function (prevProps, prevState) {
    };
    Login.prototype.submit = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var requireOTP;
            return __generator(this, function (_a) {
                requireOTP = this.state.requireOTP;
                e.preventDefault();
                if (requireOTP)
                    this.verifyOTP();
                else
                    this.signIn();
                return [2];
            });
        });
    };
    Login.prototype.signIn = function () {
        var _this = this;
        var _a = this.state, countryCode = _a.countryCode, phone = _a.phone;
        if (countryCode === "+" || !phone) {
            return;
        }
        this.setState({ processing: true });
        var phoneNumber = phone.startsWith("0") ? phone.slice(1) : phone;
        auth_1.default.signIn(countryCode + "" + phoneNumber)
            .then(function (result) {
            _this.setState({
                processing: false,
                requireOTP: true,
                seconds: 60,
                session: result,
                errorMsg: null
            });
            _this.timer();
        })
            .catch(function (e) {
            if (e.code === 'UserNotFoundException') {
                _this.signUp();
            }
            else {
                _this.setState({ processing: false, errorMsg: e.code == "NotAuthorizedException" ? "You are restricted to login for the next 5 minutes" : e.code });
            }
        });
    };
    Login.prototype.signUp = function () {
        var _this = this;
        var _a = this.state, countryCode = _a.countryCode, phone = _a.phone;
        var password = Math.random().toString(10) + 'Abc#';
        var phoneNumber = phone.startsWith("0") ? phone.slice(1) : phone;
        auth_1.default.signUp({
            username: countryCode + "" + phoneNumber,
            password: password,
            attributes: {
                phone_number: countryCode + "" + phoneNumber,
            },
        }).then(function () { return _this.signIn(); });
    };
    Login.prototype.verifyOTP = function () {
        var _this = this;
        var _a = this.state, countryCode = _a.countryCode, phone = _a.phone, otp = _a.otp, session = _a.session;
        var _b = this.props, handleChange = _b.handleChange, dispatch = _b.dispatch;
        if (countryCode === "+" || !phone || !otp || !session) {
            return;
        }
        this.setState({ processing: true });
        auth_1.default.sendCustomChallengeAnswer(session, otp)
            .then(function (user) {
            if (user.signInUserSession) {
                _this.setState({
                    processing: false,
                    loginSuccessful: true,
                    session: null
                });
                dispatch(wallet_1.loadCentralizedWallet());
                handleChange(true);
            }
            else {
                _this.setState({
                    processing: false,
                    loginSuccessful: false,
                    errorMsg: "Invalid OTP, Please enter the valid OTP.",
                });
            }
        })
            .catch(function (err) {
            if (err.message === 'Invalid session for the user.') {
                _this.setState({
                    phone: "",
                    otp: "",
                    processing: false,
                    requireOTP: false,
                    loginSuccessful: false,
                    resendOTP: false,
                    errorMsg: "Invalid OTP, Please enter the valid OTP.",
                    session: null,
                    minutes: 0,
                    seconds: 0
                });
            }
            else if (err.message === "User is disabled.") {
                _this.setState({
                    phone: "",
                    otp: "",
                    processing: false,
                    requireOTP: false,
                    loginSuccessful: false,
                    resendOTP: false,
                    errorMsg: "You are restricted to login for the next 5 minutes",
                    session: null,
                    minutes: 0,
                    seconds: 0
                });
            }
            else {
                _this.setState({
                    processing: false,
                    errorMsg: "Invalid OTP, Please enter the valid OTP.",
                });
            }
        });
    };
    Login.prototype.timer = function () {
        var _this = this;
        myInterval = setInterval(function () {
            var _a = _this.state, seconds = _a.seconds, minutes = _a.minutes;
            if (seconds > 0) {
                _this.setState(function (_a) {
                    var seconds = _a.seconds;
                    return ({
                        seconds: seconds - 1
                    });
                });
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(myInterval);
                }
                else {
                    _this.setState(function (_a) {
                        var minutes = _a.minutes;
                        return ({
                            minutes: minutes - 1,
                            seconds: 59
                        });
                    });
                }
            }
        }, 1000);
    };
    Login.prototype.componentWillUnmount = function () {
        clearInterval(myInterval);
    };
    Login.prototype.render = function () {
        var _this = this;
        var _a = this.state, phone = _a.phone, otp = _a.otp, processing = _a.processing, requireOTP = _a.requireOTP, loginSuccessful = _a.loginSuccessful, resendOTP = _a.resendOTP, minutes = _a.minutes, seconds = _a.seconds, errorMsg = _a.errorMsg, countryCode = _a.countryCode, suggestions = _a.suggestions;
        var walletTranslations = this.props.walletTranslations;
        var inputProps = {
            placeholder: "",
            value: countryCode,
            onChange: this.onChange,
            className: "custom-input2"
        };
        if (!loginSuccessful) {
            return (React.createElement(React.Fragment, null,
                React.createElement(react_device_detect_1.BrowserView, null,
                    React.createElement("form", { className: "HydroSDK-form", onSubmit: function (e) { return _this.submit(e); } },
                        React.createElement("div", { className: "HydroSDK-fieldGroup" },
                            React.createElement("div", { className: "HydroSDK-labelGroup" },
                                React.createElement("div", { className: "HydroSDK-label" }, "Enter Valid Mobile Number (Eg: XXXXXXXXXX)"),
                                React.createElement("div", { className: "HydroSDK-errorMsg" })),
                            React.createElement("div", { style: { maxHeight: '32px', zIndex: 99 } },
                                React.createElement("div", { style: { width: '100%', display: 'flex' } },
                                    React.createElement("div", { style: { flexDirection: 'row', width: '100%' } },
                                        React.createElement("div", { style: { width: '9%', display: 'inline-block' } },
                                            React.createElement("div", { style: { display: 'flex', flexDirection: 'row', border: '1px solid #e0e0e0', marginLeft: '1px' } },
                                                React.createElement("div", { style: { maxHeight: '30px', zIndex: 99 } },
                                                    React.createElement(react_autosuggest_1.default, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, onSuggestionsClearRequested: this.onSuggestionsClearRequested, getSuggestionValue: this.getSuggestionValue, renderSuggestion: renderSuggestion, inputProps: inputProps, theme: {
                                                            container: "react-autosuggest__container ",
                                                            containerOpen: "react-autosuggest__suggestions-container--open",
                                                            inputOpen: "custom-input",
                                                            suggestion: "react-autosuggest__suggestion",
                                                            suggestionHighlighted: "react-autosuggest__suggestion--highlighted ",
                                                            suggestionsList: "react-autosuggest__suggestions-list"
                                                        } })),
                                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronDown, style: { alignSelf: 'center', marginRight: '2px', background: '#f7f7f7' } }))),
                                        React.createElement("div", { style: { width: '91%', display: 'inline-block' } },
                                            React.createElement("input", { className: "custom-input", type: "text", value: phone, onChange: function (e) {
                                                    _this.setState({
                                                        phone: e.target.value,
                                                        otp: "",
                                                        processing: false,
                                                        requireOTP: false,
                                                        loginSuccessful: false,
                                                        resendOTP: false,
                                                        errorMsg: null,
                                                        session: null,
                                                        minutes: 0,
                                                        seconds: 0
                                                    });
                                                    myInterval && clearInterval(myInterval);
                                                } })))))),
                        requireOTP && React.createElement(Input_1.default, { text: otp, label: "Enter OTP", error: false, errorMsg: "", type: "text", handleChange: function (otp) { return _this.setState({ otp: otp }); } }),
                        requireOTP ? React.createElement("div", { className: "HydroSDK-desc", style: { position: "absolute", top: '296px', zIndex: 100 } }, requireOTP && (minutes === 0 && seconds === 0
                            ? React.createElement("div", { className: "HydroSDK-desc", style: { color: '#0000ee', textDecoration: 'underline', cursor: 'pointer' }, onClick: function () {
                                    _this.setState({ otp: "" });
                                    _this.signIn();
                                } }, "Resend OTP?")
                            : React.createElement("div", { className: "HydroSDK-desc" },
                                walletTranslations.loginDesc1,
                                ". Time Remaining: ", "0" + minutes,
                                ":",
                                seconds < 10 ? "0" + seconds : seconds))) :
                            React.createElement("div", { className: "HydroSDK-desc" }, walletTranslations.loginDesc),
                        errorMsg && React.createElement("div", { className: "HydroSDK-desc", style: { color: 'red', marginTop: '44px' } }, errorMsg),
                        React.createElement("button", { className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton", type: "submit", disabled: requireOTP ? processing || countryCode === "+" || !phone || !otp : processing || !phone || countryCode === "+" },
                            processing ? React.createElement("i", { className: "HydroSDK-fa fa fa-spinner fa-spin" }) : null,
                            " ",
                            requireOTP ? walletTranslations.submitOTP : walletTranslations.getOTP))),
                React.createElement(react_device_detect_1.MobileView, null,
                    React.createElement("form", { className: "HydroSDK-form", onSubmit: function (e) { return _this.submit(e); } },
                        React.createElement("div", { className: "HydroSDK-fieldGroup" },
                            React.createElement("div", { className: "HydroSDK-labelGroup" },
                                React.createElement("div", { className: "HydroSDK-label" }, "Enter Valid Mobile Number (Eg: XXXXXXXXXX)"),
                                React.createElement("div", { className: "HydroSDK-errorMsg" })),
                            React.createElement("div", { style: { maxHeight: '32px', zIndex: 99 } },
                                React.createElement("div", { style: { width: '100%', display: 'flex' } },
                                    React.createElement("div", { style: { flexDirection: 'row', width: '100%' } },
                                        React.createElement("div", { style: { width: '25%', display: 'inline-block' } },
                                            React.createElement("div", { style: { display: 'flex', flexDirection: 'row', border: '1px solid #e0e0e0', marginLeft: '1px' } },
                                                React.createElement("div", { style: { maxHeight: '30px', zIndex: 99 } },
                                                    React.createElement(react_autosuggest_1.default, { suggestions: suggestions, onSuggestionsFetchRequested: this.onSuggestionsFetchRequested, onSuggestionsClearRequested: this.onSuggestionsClearRequested, getSuggestionValue: this.getSuggestionValue, renderSuggestion: renderSuggestion, inputProps: inputProps, theme: {
                                                            container: "react-autosuggest__container",
                                                            containerOpen: "react-autosuggest__suggestions-container-mobile--open",
                                                            inputOpen: "custom-input",
                                                            suggestion: "react-autosuggest__suggestion",
                                                            suggestionHighlighted: "react-autosuggest__suggestion--highlighted ",
                                                            suggestionsList: "react-autosuggest__suggestions-list"
                                                        } })),
                                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronDown, style: { alignSelf: 'center', marginRight: '2px', background: '#f7f7f7' } }))),
                                        React.createElement("div", { style: { width: '75%', display: 'inline-block' } },
                                            React.createElement("input", { className: "custom-input", type: "text", value: phone, onChange: function (e) {
                                                    _this.setState({
                                                        phone: e.target.value,
                                                        otp: "",
                                                        processing: false,
                                                        requireOTP: false,
                                                        loginSuccessful: false,
                                                        resendOTP: false,
                                                        errorMsg: null,
                                                        session: null,
                                                        minutes: 0,
                                                        seconds: 0
                                                    });
                                                    myInterval && clearInterval(myInterval);
                                                } })))))),
                        requireOTP && React.createElement(Input_1.default, { text: otp, label: "Enter OTP", error: false, errorMsg: "", type: "text", handleChange: function (otp) { return _this.setState({ otp: otp }); } }),
                        requireOTP ? React.createElement("div", { className: "HydroSDK-desc", style: { position: "absolute", top: '296px', zIndex: 100 } }, requireOTP && (minutes === 0 && seconds === 0
                            ? React.createElement("div", { className: "HydroSDK-desc", style: { color: '#0000ee', textDecoration: 'underline', cursor: 'pointer' }, onClick: function () {
                                    _this.setState({ otp: "" });
                                    _this.signIn();
                                } }, "Resend OTP?")
                            : React.createElement("div", { className: "HydroSDK-desc" },
                                walletTranslations.loginDesc1,
                                ". Time Remaining: ", "0" + minutes,
                                ":",
                                seconds < 10 ? "0" + seconds : seconds))) :
                            React.createElement("div", { className: "HydroSDK-desc" }, walletTranslations.loginDesc),
                        errorMsg && React.createElement("div", { className: "HydroSDK-desc", style: { color: 'red', marginTop: '44px' } }, errorMsg),
                        React.createElement("button", { className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton", type: "submit", disabled: requireOTP ? processing || countryCode === "+" || !phone || !otp : processing || !phone || countryCode === "+" },
                            processing ? React.createElement("i", { className: "HydroSDK-fa fa fa-spinner fa-spin" }) : null,
                            " ",
                            requireOTP ? walletTranslations.submitOTP : walletTranslations.getOTP)))));
        }
        else {
            return null;
        }
    };
    return Login;
}(React.PureComponent));
exports.default = react_redux_1.connect(mapStateToProps)(Login);
